<!--
  暂无数据显示组件 - Ant Design 表格空数据样式
  
  使用方式：
  <empty-data />
  <empty-data title="暂无内容" />
  <empty-data title="暂无数据" description="请稍后再试" />
  
  带操作按钮：
  <empty-data title="暂无数据" description="请稍后再试">
    <template #extra>
      <a-button type="primary">刷新</a-button>
    </template>
  </empty-data>
-->
<template>
  <div class="empty-data-container">
    <div class="empty-data-content">
      <!-- 使用 Ant Design 风格的空状态图标 -->
      <div class="empty-icon">
        <svg
          width="64"
          height="41"
          viewBox="0 0 64 41"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
            <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
            <g fill-rule="nonzero" stroke="#d9d9d9">
              <path
                d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
              ></path>
              <path
                d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                fill="#fafafa"
              ></path>
            </g>
          </g>
        </svg>
      </div>
      <div class="empty-text">{{ title }}</div>
      <div class="empty-description" v-if="description">{{ description }}</div>
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, default: "暂无数据" },
    description: { type: String, default: "" },
  },
}
</script>

<style scoped>
.empty-data-container {
  width: 100%;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 16px;
  box-sizing: border-box;
}

.empty-data-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.empty-icon {
  margin-bottom: 16px;
  opacity: 1;
}

.empty-icon svg {
  display: block;
}

.empty-text {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.25);
  margin-bottom: 8px;
  line-height: 22px;
}

.empty-description {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  line-height: 1.5;
  margin-bottom: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .empty-data-container {
    min-height: 100px;
    padding: 24px 12px;
  }

  .empty-icon svg {
    width: 48px;
    height: 31px;
  }

  .empty-text {
    font-size: 12px;
  }

  .empty-description {
    font-size: 11px;
  }
}
</style>
